module.exports = __webpack_public_path__ + "img/Visa.bbc8e116.svg";